import { CareersListPage } from "@components/pages/CareersListPage"
import { SiteShell } from "@components/SiteShell"
import { careersListPageQueryOptions } from "@data/publicPageDataQuery"
import { createFileRoute } from "@tanstack/react-router"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/careers/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(careersListPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "careers", path: `/${locale}/careers` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const data = Route.useLoaderData()
  const labels = pageLabels(locale, "careers")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <CareersListPage
        data={data}
        locale={locale}
      />
    </SiteShell>
  )
}
